import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-publish-toggle-switch',
  templateUrl: './publish-toggle-switch.component.html',
  styleUrls: ['./publish-toggle-switch.component.css']
})
export class PublishToggleSwitchComponent implements OnInit {

  @Input() publishBgColor = '#b2304d';
  @Input() unpublishBgColor = '#b2b2b2';
  @Input() size = 'medium';
  @Input() model = false;
  @Output() modelChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  onModelChange(data) {
    this.modelChange.emit(data);
    this.model = data;
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/publish-toggle-switch/publish-toggle-switch.component.ts